import { useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { pushApi } from '@/lib/api';

// Automatically subscribe to Web Push when a logged-in user visits the app.
// Only asks for permission once — browser remembers the choice.
export default function usePushSubscription() {
  const { user } = useAuth();

  useEffect(() => {
    if (!user) return;
    if (!process.env.REACT_APP_VAPID_PUBLIC_KEY) return;
    if (!('Notification' in window) || !('serviceWorker' in navigator)) return;
    // Don't ask if already denied
    if (Notification.permission === 'denied') return;

    // Subscribe silently if already granted; otherwise wait for a user gesture
    if (Notification.permission === 'granted') {
      pushApi.subscribe().catch(() => {});
    }
    // If 'default' (not yet asked), we don't auto-prompt — the user triggers it
    // via the notification bell or a dedicated button to avoid intrusive prompts
  }, [user]);
}
